import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export function inventoryCount(id?: PBUUID): WebUrl {
  return {
    pathname: `/pos/counts/${UUID.idString(id)}`,
  }
}

export function inventoryCountsInProgress(): WebUrl {
  return {
    pathname: "/pos/counts/in-progress",
  }
}

export function inventoryCountsCompleted(): WebUrl {
  return {
    pathname: "/pos/counts/completed",
  }
}

export function inventoryCountsVoided(): WebUrl {
  return {
    pathname: "/pos/counts/voided",
  }
}
